import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { ManagementECReceiptDetailPresenter } from "./presenter";
import * as Repository from "../../model/repository";

type Props = {
	hotelID: string;
	receiptID: string;
};

export const ManagementECReceiptDetailContainer = memo(({ hotelID, receiptID }: Props) => {
	const { data } = Repository.Query.useSuspenseFetchEcReceiptByReceiptID({ hotelID, receiptID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.MANAGEMENT.EC_SALES.TOP, { hotelID })} />;
	}

	return <ManagementECReceiptDetailPresenter hotelID={hotelID} data={data} />;
});

ManagementECReceiptDetailContainer.displayName = "ManagementECReceiptDetailContainer";
